<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import Icon from "@kontextwerk/web-sdk/ui/primitives/Icon.svelte"
  import { mdiContentSaveOutline } from "@mdi/js"
  import type { ContactStepEditorMode } from "../../_shared/_logic/step-editor-contract"

  let {
    mode,
    saving = false,
    disabled = false,
    onSave,
  }: {
    mode: ContactStepEditorMode
    saving?: boolean
    disabled?: boolean
    onSave: () => void
  } = $props()
</script>

<CTA
  type="primaryButton"
  content={saving ? "Speichere…" : mode === "edit" ? "Speichern" : "Schritt hinzufügen"}
  onClick={onSave}
  disabled={saving || disabled}
>
  {#snippet iconSnippet()}
    <Icon path={mdiContentSaveOutline} />
  {/snippet}
</CTA>
